import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { GetResponse } from "@/api/image-shop-preview/response";
import * as ImageShopPreviewAPI from "@/api/image-shop-preview";
import { isSuccess } from "@/api/response";
import { GetRequest } from "@/api/image-shop-preview/request";

const MODULE_NAME = "image-shop-preview/get";

/**
 * 公開画像プレビュー取得API（/preview-image-shop）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getResponse: GetResponse = {} as GetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getPreviewUrl() {
    if (this.getResponse.results) {
      return this.getResponse.results.previewUrl;
    } else {
      return "";
    }
  }

  // MutationActions
  @MutationAction
  async get(getRequest: GetRequest) {
    const getResponse = await ImageShopPreviewAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as GetResponse
    };
  }
}

export default getModule(Get);
